import { TextFading, YesObject } from '@yes.technology/react-toolkit'
import { SafeHtmlContent } from 'site/shared/components/SafeHtmlContent'
import { CellContent } from './TableCell.styles'
import TableDocumentPreview from './TableDocumentPreview'

export type TableCellContentCustomAction = {
  target: string
  url: string
  label?: string
  style?: React.CSSProperties
}

export type TableCellContentProps = {
  customAction: TableCellContentCustomAction | null
  formattedValue: string | null
  value: YesObject[]
  enablePreview: boolean
  isCellTextCopied: boolean
  enableTextFading: boolean
  textFadingBackgroundColor: string | undefined
}

export default function TableCellContent({
  customAction,
  formattedValue,
  value,
  enablePreview,
  isCellTextCopied,
  enableTextFading,
  textFadingBackgroundColor
}: TableCellContentProps) {
  if (customAction) {
    return (
      <a
        target={customAction.target}
        href={customAction.url}
        rel='noopener noreferrer'
        style={customAction?.style || {}}
      >
        {customAction.label || formattedValue}
      </a>
    )
  }

  if (enablePreview) {
    return <TableDocumentPreview documents={value} />
  }

  return (
    <CellContent isCopied={isCellTextCopied} role='presentation'>
      {enableTextFading ? (
        <TextFading backgroundColor={textFadingBackgroundColor}>
          {formattedValue || ''}
        </TextFading>
      ) : (
        <SafeHtmlContent html={formattedValue || ''} />
      )}
    </CellContent>
  )
}
